import { SettingsPageLayout } from "../components/SettingsPageLayout";
import CurrencyInput from "../components/CurrencyInput";
import { useIncomeLogic } from "./Income.logic";
import { useNavigate } from "react-router-dom";

/**
 * Income page - Mobile implementation
 * Full-screen form with swipe navigation (< 768px)
 * All income values are monthly
 */
function IncomeMobile() {
  const navigate = useNavigate();
  const {
    formData,
    showCPP,
    showOAS,
    handleAmountChange,
    handleBlur,
    totalMonthlyIncome,
  } = useIncomeLogic();

  return (
    <SettingsPageLayout
      title="Income"
      category="income"
      onBack={() => navigate("/settings")}
    >
      <form className="form-page-container">
        <div className="form-page-grid">
          {/* Employment Income */}
          <CurrencyInput
            name="employmentIncome"
            value={formData.employmentIncome}
            onChange={(name, value) => handleAmountChange(name, value)}
            onBlur={() => handleBlur("employmentIncome")}
            label="Employment Income"
            helpText="Salary, wages, or self-employment income"
            suffix="/mo"
          />

          {/* Pension Income */}
          <CurrencyInput
            name="pensionIncome"
            value={formData.pensionIncome}
            onChange={(name, value) => handleAmountChange(name, value)}
            onBlur={() => handleBlur("pensionIncome")}
            label="Pension Income"
            helpText="Workplace pension or RRIF withdrawals"
            suffix="/mo"
          />

          {/* CPP Income - Only show if age >= 60 */}
          {showCPP && (
            <CurrencyInput
              name="cppIncome"
              value={formData.cppIncome}
              onChange={(name, value) => handleAmountChange(name, value)}
              onBlur={() => handleBlur("cppIncome")}
              label="CPP Income"
              helpText="Canada Pension Plan benefits"
              suffix="/mo"
            />
          )}

          {/* OAS Income - Only show if age >= 65 */}
          {showOAS && (
            <CurrencyInput
              name="oasIncome"
              value={formData.oasIncome}
              onChange={(name, value) => handleAmountChange(name, value)}
              onBlur={() => handleBlur("oasIncome")}
              label="OAS Income"
              helpText="Old Age Security benefits"
              suffix="/mo"
            />
          )}

          {/* Investment Income */}
          <CurrencyInput
            name="investmentIncome"
            value={formData.investmentIncome}
            onChange={(name, value) => handleAmountChange(name, value)}
            onBlur={() => handleBlur("investmentIncome")}
            label="Investment Income"
            helpText="Dividends, interest, capital gains"
            suffix="/mo"
          />

          {/* Rental Income */}
          <CurrencyInput
            name="rentalIncome"
            value={formData.rentalIncome}
            onChange={(name, value) => handleAmountChange(name, value)}
            onBlur={() => handleBlur("rentalIncome")}
            label="Rental Income"
            helpText="Income from rental properties"
            suffix="/mo"
          />

          {/* Other Income */}
          <CurrencyInput
            name="otherIncome"
            value={formData.otherIncome}
            onChange={(name, value) => handleAmountChange(name, value)}
            onBlur={() => handleBlur("otherIncome")}
            label="Other Income"
            helpText="Any other income sources"
            suffix="/mo"
          />
        </div>
      </form>

      {/* Total (calculated, read-only) - Fixed at bottom on mobile */}
      <div className="form-page-total-bar">
        <div className="form-page-total-row">
          <span className="form-page-total-label">Total Monthly Income</span>
          <span id="total" className="form-page-total-value-green">
            ${totalMonthlyIncome.toLocaleString()}
          </span>
        </div>
      </div>
    </SettingsPageLayout>
  );
}

export default IncomeMobile;
